import { getEnv, Instance, SnapshotOut, types } from "mobx-state-tree"
import { SettingsInfoData, Event, WalletSwitchData, OrderProposalData } from "../../proto/nbchat-proto"
const config = require("../../config/env")

const ws_arr = String(config.WS_URL || "")
  .split(",")
  .map((s: string) => s.trim())
  .filter(Boolean)
const defaultWs = ws_arr[0] || ""

/**
 * ConfigStore 用于存储一些系统配置
 */
export const ConfigStoreModel = types
  .model("ConfigStore")
  .props({
    ws_arr: types.optional(types.array(types.string), ws_arr),
    ws: types.optional(types.string, defaultWs),
    api: types.optional(types.string, config.API_URL),
    cdn: types.optional(types.string, config.CDN_URL),
    appName: types.optional(types.string, config.APP_NAME),
    redirectURL: types.optional(types.string, config.REDIRECT_URL),
    appKey: types.optional(types.string, config.APP_KEY),
    order_proposal_min: types.maybeNull(types.optional(types.number, 0)),
    order_proposal_max: types.maybeNull(types.optional(types.number, 0)),
    wallet_on: types.optional(types.boolean, false),
    order_proposal_on: types.optional(types.boolean, false),
  })
  .views((self) => ({
    get upload_url() {
      return self.api + "/upload/file"
    },
  }))
  .actions((self) => ({
    setWS(ws: string) {
      self.ws = ws
    },
    switchWS() {
      if (!self.ws_arr.length) return
      const next =
        self.ws_arr[Math.floor(Math.random() * self.ws_arr.length)] ||
        self.ws_arr[0]
      self.ws = next
    },
    setAPI(url: string) {
      self.api = url
      const { api } = getEnv(self)
      api.config.update({ url })
    },
    setCDN(url: string) {
      self.cdn = url
    },
    update(data: Partial<ConfigStore>) {
      Object.keys(data).forEach((key) => {
        self[key] = data[key]
      })
    },
    onSettingInfo({ data }: Event<SettingsInfoData>) {
      self.order_proposal_min = Number(data.order_proposal_min)
      self.order_proposal_max = Number(data.order_proposal_max)
      self.wallet_on = data.wallet_on
      self.order_proposal_on = data.order_proposal_on
    },
    onWalletSwitched({ data }: Event<WalletSwitchData>) {
      self.wallet_on = data.active
    },
    onOrderProposalChanged({ data }: Event<OrderProposalData>) {
      self.order_proposal_min = Number(data.order_proposal_min)
      self.order_proposal_max = Number(data.order_proposal_max)
      self.order_proposal_on = data.order_proposal_on
    },
  }))

type ConfigStoreType = Instance<typeof ConfigStoreModel>
export interface ConfigStore extends ConfigStoreType {}
type ConfigStoreSnapshotType = SnapshotOut<typeof ConfigStoreModel>
export interface ConfigStoreSnapshot extends ConfigStoreSnapshotType {}
export const createConfigStoreDefaultModel = () => types.optional(ConfigStoreModel, {})
